
import { defineComponent } from 'vue'
import { mapMutations, mapState } from 'vuex'
import PostbackNoteDialog from '@/components/dialogs/PostbackNoteDialog.vue'
import { getPostbackTypes } from '@/utils/postbacks'
import { Postback } from '@/store/types'

export default defineComponent({
  name: 'Postbacks',
  components: { PostbackNoteDialog },
  computed: {
    ...mapState('campaignsModule', ['campaign', 'errors']),
    ...mapState('authModule', ['isMB']),
  },
  async created() {
    this.errors = {}
    this.postbacks = [...this.campaign.postbacks] as never[]

    if (!this.postbacks?.length) {
      this.createPostback()
    }
  },
  data: function() {
    return {
      showPostbackNoteDialog: false,
      postbacks: [],
      postbackTypes: getPostbackTypes(),
    }
  },
  watch: {
    postbacks: {
      handler() {
        this.updatePostbacks()
      },
      deep: true,
    },
  },
  methods: {
    ...mapMutations('campaignsModule', ['update']),
    createPostback() {
      ;(this.postbacks as Postback[]).push({
        types: this.postbackTypes.map(({ value }) => value),
        url: '',
      })
    },
    addPostback() {
      this.createPostback()
      this.update({ postbacks: [...this.postbacks] })
    },
    updatePostbacks() {
      this.update({ postbacks: this.postbacks })
    },
    removePostback(index: number) {
      this.postbacks.splice(index, 1)
      this.updatePostbacks()
    },
  },
})
